import { cn } from '@bem-react/classname';

export const cnKhAnnouncementScreen = cn('KhAnnouncementScreen');
